<template>
    <div class="contact page">
        <form @submit.prevent="handleSubmit" 
            name="contact" 
            method="post" 
            data-netlify="true" 
            data-netlify-honeypot="bot-field"
            >
            <h1 class="page-title">Get In Touch</h1>
            <input type="hidden" name="form-name" value="contact" />
            <div class="input"> 
                <label>Name</label>
                <input name="name" v-model="form.name" type="text"/>
            </div>
            <div class="input">
                <label>Email</label>
                <input name="email" v-model="form.email" type="text"/>
            </div>
            <div class="input">
                <label>Message</label>
                <textarea name="message" v-model="form.message"/>
            </div>
            <button class="button button-blue">Submit</button>
        </form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import axios from "axios";

export default {
    name: 'Contact',
    data() {
        return {
            form: {
                name: '',
                email: '',
                message: ''
            }
        }
    },
    methods: {
        ...mapActions(['showMenu', 'hideFooter']),
        encode(data) {
            return Object.keys(data)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
            .join('&')
        },
        handleSubmit() {
            const axiosConfig = {
                header: { "Content-Type": "application/x-www-form-urlencoded" }
            };
            axios.post(
                "/",
                this.encode({
                    "form-name": "contact",
                    ...this.form
                }),
                axiosConfig
            )
            .then(() => {
                this.$router.push('thanks');
            })
            .catch(() => {
                this.$router.push('fail');
            });
        }
    },
    created() {
        this.showMenu();
        this.hideFooter();
    }
}
</script>

<style scoped>
.contact {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
form {
    display: flex;
    flex-direction: column;
    width: 85%;
}
.input {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 20px;
}
.input label {
    display: block;
    color: var(--blue);
}
.input input, .input textarea {
    border: 1px solid var(--dark2);
    border-radius: 2px;
    padding: 8px 10px;
    font-size: 1em;
    font-family: lato-regular;
}
.input textarea {
    height: 100px;
}
button {
    align-self: flex-end;
}

@media (min-width: 410px) {
    form {
        width: 330px
    }
}
@media (min-width: 768px) {
    form {
        width: 500px
    }
}
</style>